import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import "./personalisationModal.css";
import cross from "../assets/x-solid.svg";
import { ShopContext } from "../../context/shopContext";

const PersonalisationModal = (props) => {
    const { closePersonalisationModal, onMessageSuccess } = props;
    const { addToCart } = useContext(ShopContext);
    const [text, setText] = useState("");


    const handleAddMessageClick = () => {
        const itemId = props.id;
        const personalisation = text;

        addToCart({ itemId, personalisation });

        onMessageSuccess();

        closePersonalisationModal(false);
    };


    return (
        <div className="modal-background">
            <div
                className="modal-cancel-background"
                onClick={() => closePersonalisationModal(false)}
            ></div>

            <div className="modal-container">
                <img
                    className="exit-btn"
                    onClick={() => closePersonalisationModal(false)}
                    src={cross}
                    alt="Close"
                />
                <div className="personalisation-textarea-container">
                    <textarea
                        className="personalisation-textarea"
                        type="textarea"
                        maxLength="100"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="Do your worst, peasant"
                    />
                </div>
                <p className="character-count">
                    Characters remaining: {100 - text.length}
                </p>
                <Link to='/cart'>
                    <button onClick={handleAddMessageClick}>Add Message</button>
                </Link>
            </div>
        </div>
    );
};

export default PersonalisationModal;
